import axios from 'axios';
import {withoutComma} from "../../utils/calculate/Amount";

export class CaptureLoanableValuesService {
    getListPositionsCaptureValues() {
        return axios.get('/appapv/listPositionsCaptureValues.action', {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(res => res.data.payload);
    }

    getListOrdersLoanableValues(idEmisora, account) {
        return axios.get('/appapv/listOrdersLoanableValues.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idEmisora: idEmisora,
                cuenta: account,
            }
        }).then(res => res.data.payload);
    }

    addPosition(positionData) {
        return axios.post('/appapv/addLoanableValues.action', {}, {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idEmisora: positionData.idEmisora,
                cuenta: positionData.cuenta,
                folio: positionData.folio ? positionData.folio : '',
                cantidadPostura: withoutComma(positionData.cantidad.toString()),
                plazo: withoutComma(positionData.plazo.toString()),
                tasa: withoutComma(positionData.tasa.toString()),
                sobreTasa: positionData.sobreTasa ? withoutComma(positionData.sobreTasa.toString()) : 0,
                premioMin: positionData.premioMin ? withoutComma(positionData.premioMin.toString()) : 0,
                restricciones: positionData.restricciones,
                fecValor: positionData.fecValor,
                banderaOtc: positionData.banderaOtc ? 1 : 0,
                vigencia: positionData.vigencia,
            }
        }).then(res => {
            this.getListOrdersLoanableValues();
            return res.data;
        });
    }

    updateLoanableValues(positionData) {
        return axios.put('/appapv/updateLoanableValues.action', {}, {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idEmisora: positionData.idEmisora,
                cuenta: positionData.cuenta,
                folio: positionData.folio ? positionData.folio : '',
                cantidadPostura: withoutComma(positionData.cantidad.toString()),
                plazo: withoutComma(positionData.plazo.toString()),
                tasa: withoutComma(positionData.tasa.toString()),
                sobreTasa: positionData.sobreTasa ? withoutComma(positionData.sobreTasa.toString()) : 0,
                premioMin: positionData.premioMin ? withoutComma(positionData.premioMin.toString()) : 0,
                restricciones: positionData.restricciones,
                fecValor: positionData.fecValor,
                banderaOtc: positionData.banderaOtc ? 1 : 0,
            }
        }).then(res => {
            this.getListOrdersLoanableValues();
            return res.data;
        });
    }

    cancelPosition(folio) {
        return axios.delete('/appapv/deleteLoanableValues.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                folio: folio,
            }
        }).then(res => {
            this.getListOrdersLoanableValues();
            return res.data;
        });
    }

}